import { Component, OnInit, Inject,Input, Output,EventEmitter, ViewEncapsulation, ViewChild, ElementRef, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { QuoteDataCaptureService, UtilService, SERVICE_END_POINT } from 'src/app/shared';



@Component({
  selector: 'app-session-timeout',
  templateUrl: './session-timeout.component.html',
  styleUrls: ['./session-timeout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SessionTimeoutComponent implements OnInit {
  contentData: any;
  counter = 120;
  tick = 1000;
  public countDown;
  public CMSData;

  public string_LoggingOutTimingWording;
  public string_KeepLoggedInCTALabel;
  public string_ContinueSessionCTALabel;
  public string_SessionClosingWording;

  @Output() continueWithMySession: EventEmitter<any> = new EventEmitter<any>();
  @Output() sessionLogout: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("continueBtn", { static: true }) continueBtn: ElementRef;
  @ViewChild("loginBtn", { static: true }) loginBtn: ElementRef;
  @ViewChild("registerBtn", { static: true }) registerBtn: ElementRef;
  @ViewChild("logoutBtn", { static: true }) logoutBtn: ElementRef;
  @Input() userDetails;
  isUserLogin = false;
  public count: number = 0;
  constructor(@Inject(DOCUMENT) private document: any,
              private fb: UntypedFormBuilder, private router: Router,
              private activatedRoute: ActivatedRoute,
              private quoteDatacaptureService: QuoteDataCaptureService,
              private utilService: UtilService) {
                //console.log(this.activatedRoute);
 // this.contentData = this.activatedRoute.snapshot.data.contentData.headerData;
}
  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.countDown=  this.getCounter();
    if(this.userDetails) {
      this.isUserLogin = false;
    } else {
      this.isUserLogin = true;
    }
  }

  logout() {
     this.sessionLogout.emit(true);
  }

  login() {
    this.continueWithMySession.emit(true);
    this.quoteDatacaptureService.onLoginClick();
  }

  continueSession() {
   this.continueWithMySession.emit(true);
  }

  getCounter() {
    return Observable.timer(0, this.tick)
      .take(this.counter)
      .map(() => this.counterCount(--this.counter))
  }

  counterCount(value){
    const minutes: number = Math.floor(value / 60);
    return ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2);
  }

  registration() {
    this.continueWithMySession.emit(true);
    this.router.navigate(['/home/registration']);
  }

 /** Code block for CMS */
 GetCMSDataServiceMapper() {
  const URL = SERVICE_END_POINT.higherEnvironment.CMS_ShortModal_BeforeTimeout;
  //console.log('changed value = ', this.contentData);
  this.utilService.getCMSData(URL).subscribe(res => {
    //console.log('2 GetCMSDataService => ', res);
    this.CMSData = res;
    if (this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.string_LoggingOutTimingWording = this.CMSData.string_LoggingOutTimingWording;
      this.string_KeepLoggedInCTALabel = this.CMSData.string_KeepLoggedInCTALabel;
      this.string_ContinueSessionCTALabel = this.CMSData.string_ContinueSessionCTALabel;
      this.string_SessionClosingWording = this.CMSData.string_SessionClosingWording;
    }
  });
}
/** End of code block for CMS */

setFocus() {
  this.continueBtn.nativeElement.focus();
}
@HostListener('document:keydown', ['$event']) circulateTabbing(event) {
  if (!(event.shiftKey) && event.keyCode === 9) {
    if (this.count === 0) {
      this.count++;
    } else if (this.count === 3 && this.isUserLogin) {
      this.count = 1;
    } else if (this.count === 4 && !this.isUserLogin) {
      this.count = 1;
    }

    switch (true) {
      case this.count === 1: this.continueBtn.nativeElement.focus();
                             this.count++;
                             break;
      case this.count === 2: this.loginBtn.nativeElement.focus();
                             this.count++;
                             break;
      case this.count === 3: this.registerBtn.nativeElement.focus();
                             this.count++;
                             break;
                             default: break;
    }

  } else if (event.shiftKey && event.keyCode === 9) {
    if (this.count === 0) {
      this.count++;
    } else if (this.count === 4) {
      this.count = 3;
    }

    switch (true) {
      case this.count === 1: this.loginBtn.nativeElement.focus();
                             this.count = 3;
                             break;
      case this.count === 2: this.continueBtn.nativeElement.focus();
                             this.count--;
                             break;
      case this.count === 3: this.registerBtn.nativeElement.focus();
                             this.count--;
                             break;
      default: break;
    }
  }
  }
}
